<template lang="pug">
  SspLayout.business-location-edit(area="tnt")
    template(slot="actions")
      button.edit-permissions-button.btn.btn-default(v-if="locationId" @click='showPermissionsDialog()')
        i.fa.fa-group
        span.ml5 Permissions
    .row
      .col-sm-12
        SspSaveForm(@onSubmit="save" :saving="saving" :saveDisabled="!isValid")
          .form-group
            label.col-sm-2.control-label Name
            .col-sm-10
              input.form-control.name-input(type="text" v-model="name")
          .form-group
            label.col-sm-2.control-label Category
            .col-sm-10
              business-location-type.form-control(id="location-type-select" v-model="category")
          .form-group
            label.col-sm-2.control-label Parent location
            .col-sm-10
              LocationPicker(v-model="parentLocation")
          .form-group
            label.col-sm-2.control-label Geo location
            .col-sm-10.location-lookup-picker
              LocationPicker.lookup(v-model="geoLocation" :searchFunction="geoLocationsSearchFunction")
          .form-group
            label.col-sm-2.control-label Coordinates
            label.col-sm-1.control-label.width0 Lat
            .col-sm-2
              input.form-control(disabled :value="coordinates.lat")
            label.col-sm-1.control-label.width0 Lng
            .col-sm-2
              input.form-control(disabled :value="coordinates.lng")
            .col-sm-1
              WorldCoordinates.inline(v-model="coordinates")
              PickLocationMarker.marker(@onCoordinatesPicked="onGeoLocationCoordinates" v-model="coordinates")

            .col-sm-3
              .text-right
                button.btn.btn-primary(@click="$refs.locationTreeModal.open()") Open Location Tree

          .form-group
            label.col-sm-2.control-label Gln
            .col-sm-10
              input.form-control.gln-input(type="text" v-model="gln")
          .form-group
            label.col-sm-2.control-label City
            .col-sm-10
              input.form-control.city-input(type="text" v-model="city")
          .form-group
            label.col-sm-2.control-label Address
            .col-sm-10
              input.form-control.address-input(type="text" v-model="address")
          .form-group
            label.col-sm-2.control-label Zip code
            .col-sm-10
              input.form-control.zip-code-input(type="text" v-model="zipCode")
          .form-group
            label.col-sm-2.control-label Uri
            .col-sm-10
              input.form-control.zip-code-input(type="text" v-model="uri")

    LocationTreeModal(ref="locationTreeModal" @setGeoLocation="setGeoLocation")
    Permissions(ref='permissions')
</template>
<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'
import PickLocationMarker from '@/components/common/PickLocationMarker'
import WorldCoordinates from '@/components/common/WorldCoordinates'
import LocationPicker from '@/components/ssp/LocationPicker'
import TrackNTrace from '@/service/apis/TrackNTrace'
import Permissions from '@/components/ssp/Permissions'
import LocationTreeModal from '@/components/ssp/LocationTreeModal'

export default {
  data: () => ({
    saving: false,
    name: null,
    category: null,
    parentLocation: null,
    geoLocation: null,
    coordinates: {
      lat: null,
      lng: null
    },
    country: {
      code: null,
      name: null
    },
    gln: null,
    city: null,
    address: null,
    zipCode: null,
    uri: null
  }),
  created() {
    if (this.locationId) {
      TrackNTrace.findBusinessLocation(this.locationId)
        .then((resp) => {
          this.name = resp.data.name
          this.gln = resp.data.gln
          this.city = resp.data.city
          this.address = resp.data.address
          this.category = resp.data.category
          this.zipCode = resp.data.zipCode
          this.uri = resp.data.uri
          if (resp.data.geoLocationId) {
            TrackNTrace.findGeolocationById(resp.data.geoLocationId)
              .then((g) => {
                this.coordinates.lng = g.data.coordinates.lng
                this.coordinates.lat = g.data.coordinates.lat
                this.geoLocation = g.data
              })
              .catch((e) => { this.$emit('error', e) })
          }
          if (resp.data.parentLocationId) {
            TrackNTrace.findBusinessLocation(resp.data.parentLocationId)
              .then((pl) => {
                this.parentLocation = pl.data
              })
              .catch((e) => { this.$emit('error', e) })
          }
        })
    }
  },
  methods: {
    setGeoLocation(data) {
      this.geoLocation = data
      this.coordinates.lat = data.coordinates.lat
      this.coordinates.lng = data.coordinates.lng
    },
    showPermissionsDialog() {
      this.$refs.permissions.open('LOCATION', this.locationId)
    },
    save() {
      this.saving = true
      const req = {
        address: this.address,
        category: this.category,
        city: this.city,
        coordinates: this.coordinates,
        geoLocationId: this.geoLocation ? this.geoLocation.id : null,
        gln: this.gln ? this.gln : null,
        name: this.name,
        parentLocationId: this.parentLocation ? this.parentLocation.id : null,
        zipCode: this.zipCode,
        uri: this.uri
      }
      if (this.geoLocation && this.geoLocation.country) {
        req.country = {
          name: this.geoLocation.country.name,
          code: this.geoLocation.country.code
        }
      }

      const call = this.locationId ? TrackNTrace.updateBusinessLocation(this.locationId, req) : TrackNTrace.createBusinessLocation(req)
      const action = !this.locationId ? 'created' : 'updated'
      return call
        .then(() => {
          miniToastr.success(`Business location ${action}`)
          this.$router.push('/trackntrace/business-locations')
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    },
    geoLocationsSearchFunction() {
      return TrackNTrace.listGeoLocations
    },
    onGeoLocationCoordinates(c) {
      this.coordinates = c
      const req = { maxDistance: 100, ...c }
      TrackNTrace.findGeolocationByCoordinates(req)
        .then((l) => {
          this.geoLocation = l.data
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    geoLocationSelected(location) {
      if (location) {
        this.coordinates = location.coordinates
      } else {
        this.coordinates = {}
      }
    }
  },
  watch: {
    geoLocation() {
      this.coordinates = this.geoLocation.coordinates
    }
  },
  computed: {
    locationId() {
      return parseInt(this.$route.params.id, 10)
    },
    isValid() {
      const geoOrParentSet = this.geoLocation || this.parentLocation
      return geoOrParentSet && this.name && this.category
    }
  },
  components: {
    LocationPicker,
    PickLocationMarker,
    WorldCoordinates,
    Permissions,
    LocationTreeModal
  }
}

Vue.component('business-location-type', {
  template: '<select v-model="selectedType" @change="onChange()"><option v-for="i in businessLocationTypes" v-bind:value="i">{{i}}</option></select>',
  props: ['value'],
  data() {
    return {
      selectedType: '',
      businessLocationTypes: ['OTHER', 'TRANSPORT_POINT', 'MANUFACTURER', 'WAREHOUSE', 'DISTRIBUTION_CENTER', 'WHOLESALER', 'POINT_OF_SALE']
    }
  },
  watch: {
    value(v) {
      this.selectedType = v
    }
  },
  methods: {
    onChange() {
      this.$emit('input', this.selectedType)
    }
  }
})

</script>

<style lang="scss">
.business-location-edit {
  .width0 {
    width: 0;
  }
  .float-right {
    float: right;
  }
  .inline {
    display: block;
    float: left;
    padding-right: 60px;
  }

  .location-tree {
    cursor: pointer;
  }

  .location-lookup-picker {
    display: flex;
    .lookup {
      width: 100%;
    }
  }
  .marker {
    position: absolute;
    right: 0;
    color: #EA4335;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/BusinessLocation.vue